module.exports = __webpack_public_path__ + "static/ai-3-3bed7129e07941ceb254f38179612d48.png";